module.exports = __webpack_public_path__ + "static/media/sleekflow-logo.19ca92b6.svg";